export const AuthConstants = {

    /* Regex */
    // Angular's regex validators don't work!!!! Validators are very unreliable when used in forms. Angular offers various ways to implement pattern validation and they all fail in some scenario. Build your own!

    // Test expressions on regex101.com
   passwordMinLength : 12,
   passwordMaxLength : 64,
   passwordRegexPattern : /^[^\n\r\u2028\u2029]{12,}$/u // NOTE!! Angular will at the ^ at the start and the $ at the end
   /*
    Explanation:
    ^ start of string
    [^\n\r\u2028\u2029] any character except a line break: letters of any script, digits, symbols, spaces
    {12,} the string has a minimum length of 12; the maximum is passwordMaxLength
    $ end of the string

    There are deliberately no composition rules. Weak passwords are blocked by the backend's
    breached-password check, shown as 'authentication.password_compromised'.
   */

}